module.exports = __webpack_public_path__ + "static/media/Dsdl_logo.a7b0630c.jfif";